import wxUtils from '@/commons/utils/wx';
import systemService from '@/services/system.service';
import { UserModule } from '@/store/modules/user';
import { Notify } from 'vant';
import { NavigationGuardNext } from 'vue-router/types/router';

export default class RouterInterceptors {
    // 获取token
    public static async getToken(next: NavigationGuardNext) {
        try {
            // 企业微信登录
            const weiXinWorkCode: string | null = wxUtils.getCode();
            if (!weiXinWorkCode) {
                // Notify({ type: 'danger', message: '登录失败', duration: 0 });
                await UserModule.reLogin();
            } else {
                const { code, token, data, message } = await systemService.wxWorkAutoLogin(weiXinWorkCode);

                if (token) {
                    UserModule.SET_USER_TOKEN(token);
                    next();
                } else {
                    Notify({ type: 'danger', message });
                }
            }
        } catch (e) {
            Notify({ type: 'danger', message: '企业微信环境异常', duration: 0 });
            // await this.$router.replace({ path: '/401' });
        }
    }
}
